import { AxiosResponse } from "axios";
import { httpClient } from "src/shared/services/httpClient";
import { ParametricType } from "src/shared/types";

export const confirmAccount = ({
  iban,
}: {
  iban: string;
}): Promise<AxiosResponse> =>
  httpClient.get("/wsConsumers/confirmAccount", {
    params: {
      iban: iban,
    },
  });

export const getTitlosAdeiaArithmos = ({
  adeiaArithmos,
  entypoEidosId,
}: {
  adeiaArithmos: number;
  entypoEidosId: number | null;
}): Promise<AxiosResponse> =>
  httpClient.get("/wsConsumers/getTitlosAdeiaArithmos", {
    params: {
      adeiaArithmos: adeiaArithmos,
      entypoEidosId: entypoEidosId,
    },
  });

export const checkPassport = ({
  passportNumber,
  name,
  surname,
}: {
  passportNumber: string | null | undefined;
  name: string | null | undefined;
  surname: string | null | undefined;
}): Promise<AxiosResponse> =>
  httpClient.get("/wsConsumers/checkPassport", {
    params: {
      passportNumber: passportNumber,
      name: name,
      surname: surname,
    },
  });

export const searchIdentitiesById = ({
  adt,
}: {
  adt: string | null | undefined;
}): Promise<AxiosResponse<{ isActive: boolean }>> =>
  httpClient.get("/wsConsumers/searchIdentitiesById", {
    params: {
      adt: adt,
    },
  });

export const getStayDocumentTypes = (): Promise<
  AxiosResponse<ParametricType[]>
> => httpClient.get("/wsConsumers/getStayDocumentTypes");
